import React, { Component } from 'react';

import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

import LoadingIndication from '../../common/loading-indicator';
import adminStatsService from '../../../services/admin-stats/admin-stats';
import { colors } from './common';

class LineChartOvertimeStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,      
      stats: [],
    };
  }

  componentDidMount() {
    adminStatsService.getFBPostsOverTime()
      .then((stats) => {
        this.setState(() => {
          return {
            isLoading: false,
            isError: false,
            stats,
            xKeys: stats.length > 0 ? Object.keys(stats[0]).filter(x=>x!=='date') : [],
          };
        }); 
      })
      .catch(error => {
        console.error('FBPostsOvertimeStats::componentDidMount', error);
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingIndication />;
    }

    if (this.state.isError) return <div>Error</div>;

    const { stats, xKeys } = this.state;

    const xKeysSeparation = [];
    const tagsPerChart = 100;
    for (let i = 0; i < xKeys.length; i += tagsPerChart) {
      xKeysSeparation.push(xKeys.slice(i, i + tagsPerChart));
    } 

    return (
      <div>
        {
          xKeysSeparation.map(xKeys => (
            <Chart stats={stats} xKeys={xKeys} />
          ))
        }
      </div>
    );
  }
}

const Chart = ({ stats, xKeys }) => (
  <LineChart
    width={1000}
    height={400}
    data={stats}
    margin={{
      top: 5, right: 30, left: 20, bottom: 5,
    }}
  >

    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="date" />
    <YAxis />
    <Tooltip />
    <Legend />
    {
      xKeys.map((xKey, i) => (
        <Line key={i} type="monotone" stroke={colors[i]} dataKey={xKey} activeDot={{ r: 8 }} 
          label={{ fill: 'black', fontSize: 16 }}
        />
      ))
    }
  </LineChart>
);

export default LineChartOvertimeStats;
